import { Injectable } from '@angular/core';
import { Provider } from '../provider';
import { ISession } from 'src/app/models/session.model';

@Injectable()
export class EventSessionService extends Provider<ISession> {
  protected url = "events/sessions";
}
